import {
    createNewProgramModel,
    createNewProgramFlow,
} from './newProgram';
import {
    createMergeProgramsModel,
    createMergeProgramsFlow,
} from './mergePrograms';
import {
    createConsolidateProgramsModel,
    createConsolidateProgramsFlow,
} from './consolidatePrograms';
import {
    createChangeDetailsModel,
    createChangeDetailsFlow,
} from './changeDetails';
import {
    createChangeStatusModel,
    createChangeStatusFlow,
} from './changeStatus';
import {
    createSplitProgramModel,
    createSplitProgramFlow,
} from './splitProgram';

export const createFlowRegistry = {
    createNew: {
        initialize: createNewProgramModel,
        submit: createNewProgramFlow,
    },
    merge: {
        initialize: createMergeProgramsModel,
        submit: createMergeProgramsFlow,
    },
    consolidate: {
        initialize: createConsolidateProgramsModel,
        submit: createConsolidateProgramsFlow,
    },
    changeDetails: {
        initialize: createChangeDetailsModel,
        submit: createChangeDetailsFlow,
    },
    changeStatus: {
        initialize: createChangeStatusModel,
        submit: createChangeStatusFlow,
    },
    split: {
        initialize: createSplitProgramModel,
        submit: createSplitProgramFlow,
    },
};
